import React from "react";
import { Github, Linkedin, FileText, Mail, MapPin, Terminal } from "lucide-react";
import { personalInfo } from "../data/mock";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer
      style={{
        background: "var(--bg-primary)",
        borderTop: "2px solid var(--border-medium)",
        padding: "60px 7.6923% 40px",
      }}
    >
      <div
        style={{
          maxWidth: "1400px",
          margin: "0 auto",
        }}
      >
        {/* Main Footer Content */}
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
            gap: "40px",
            marginBottom: "40px",
          }}
        >
          {/* Brand Section */}
          <div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "12px",
                marginBottom: "16px",
              }}
            >
              <Terminal size={28} color="var(--brand-primary)" />
              <span
                style={{
                  fontSize: "24px",
                  fontWeight: 600,
                  color: "var(--text-primary)",
                }}
              >
                {personalInfo.name}
              </span>
            </div>
            <p
              style={{
                fontSize: "16px",
                color: "var(--text-muted)",
                lineHeight: "1.6",
              }}
            >
              {personalInfo.title}
              <br />
              {personalInfo.tagline}
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3
              style={{
                fontSize: "18px",
                fontWeight: 600,
                color: "var(--text-primary)",
                marginBottom: "16px",
              }}
            >
              Quick Links
            </h3>
            <ul
              style={{
                listStyle: "none",
                padding: 0,
                margin: 0,
                display: "flex",
                flexDirection: "column",
                gap: "12px",
              }}
            >
              {["About", "Skills", "Experience", "Projects", "Contact"].map((item) => (
                <li key={item}>
                  <a
                    href={`#${item.toLowerCase()}`}
                    style={{
                      fontSize: "16px",
                      color: "var(--text-muted)",
                      textDecoration: "none",
                      transition: "color 0.3s ease",
                    }}
                    onMouseEnter={(e) => (e.target.style.color = "var(--brand-primary)")}
                    onMouseLeave={(e) => (e.target.style.color = "var(--text-muted)")}
                  >
                    {item}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3
              style={{
                fontSize: "18px",
                fontWeight: 600,
                color: "var(--text-primary)",
                marginBottom: "16px",
              }}
            >
              Get in Touch
            </h3>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "12px",
              }}
            >
              <a
                href={`mailto:${personalInfo.email}`}
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                  fontSize: "16px",
                  color: "var(--text-muted)",
                  textDecoration: "none",
                  transition: "color 0.3s ease",
                }}
                onMouseEnter={(e) => (e.target.style.color = "var(--brand-primary)")}
                onMouseLeave={(e) => (e.target.style.color = "var(--text-muted)")}
              >
                <Mail size={18} />
                {personalInfo.email}
              </a>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                  fontSize: "16px",
                  color: "var(--text-muted)",
                }}
              >
                <MapPin size={18} />
                {personalInfo.location}
              </div>
            </div>
          </div>

          {/* Social Links */}
          <div>
            <h3
              style={{
                fontSize: "18px",
                fontWeight: 600,
                color: "var(--text-primary)",
                marginBottom: "16px",
              }}
            >
              Connect
            </h3>
            <div
              style={{
                display: "flex",
                gap: "16px",
              }}
            >
              <a
                href={personalInfo.github}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "44px",
                  height: "44px",
                  background: "rgba(255, 255, 255, 0.05)",
                  borderRadius: "0px",
                  transition: "all 0.3s ease",
                  border: "1px solid var(--border-subtle)",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.background = "var(--brand-primary)";
                  e.currentTarget.style.borderColor = "var(--brand-primary)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.background = "rgba(255, 255, 255, 0.05)";
                  e.currentTarget.style.borderColor = "var(--border-subtle)";
                }}
              >
                <Github size={20} color="var(--text-primary)" />
              </a>
              <a
                href={personalInfo.linkedin}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "44px",
                  height: "44px",
                  background: "rgba(255, 255, 255, 0.05)",
                  borderRadius: "0px",
                  transition: "all 0.3s ease",
                  border: "1px solid var(--border-subtle)",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.background = "var(--brand-primary)";
                  e.currentTarget.style.borderColor = "var(--brand-primary)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.background = "rgba(255, 255, 255, 0.05)";
                  e.currentTarget.style.borderColor = "var(--border-subtle)";
                }}
              >
                <Linkedin size={20} color="var(--text-primary)" />
              </a>
              <a
                href={personalInfo.medium}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "44px",
                  height: "44px",
                  background: "rgba(255, 255, 255, 0.05)",
                  borderRadius: "0px",
                  transition: "all 0.3s ease",
                  border: "1px solid var(--border-subtle)",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.background = "var(--brand-primary)";
                  e.currentTarget.style.borderColor = "var(--brand-primary)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.background = "rgba(255, 255, 255, 0.05)";
                  e.currentTarget.style.borderColor = "var(--border-subtle)";
                }}
              >
                <FileText size={20} color="var(--text-primary)" />
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div
          style={{
            borderTop: "1px solid var(--border-subtle)",
            paddingTop: "30px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            flexWrap: "wrap",
            gap: "20px",
          }}
        >
          <p
            style={{
              fontSize: "14px",
              color: "var(--text-muted)",
              margin: 0,
            }}
          >
            © {currentYear} {personalInfo.name}. All rights reserved.
          </p>
          <p
            style={{
              fontSize: "14px",
              color: "var(--text-muted)",
              margin: 0,
            }}
          >
            Built with React & Framer Motion | Designed with security in mind
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
